import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi, EmergenzaAssistitoDTO, EmergenzaAssistitoUpdateDTO, EmergenzeApi, OperatoriApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { LoadPanel, Lookup, RadioGroup, TextArea } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
import { isUndefined } from 'util';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import { usePuntiDiRaccoltaDataSource } from '../../datasources/PuntiDiRaccoltaDataSource';
import { Layout } from '../../Content';
// import { useComuniDataSource } from '../../datasources/ComuniDataSource'; //todo: RGAM non esiste più datasource comuni.

type Props = {
  emergenzaAssistitoId?: string;
  onchanged?: () => void;
}

export type EmergenzaAssistitoCompletaPanelHandle = {
  save: () => Promise<boolean>;
}

type state = {
  isNew: boolean
}

const EmergenzaAssistitoCompletaPanel: React.ForwardRefRenderFunction<EmergenzaAssistitoCompletaPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const puntiDiRaccoltaDataSource = usePuntiDiRaccoltaDataSource();

  useEffect(() => {
    setFormData(undefined);

    (async function () {
      const api = new EmergenzeApi(apiConfiguration);
      setLoadPanelVisible(true);

      if (props.emergenzaAssistitoId) {
        setFormData(await api.getCurrentEmergenzaAssistitoById({ tenantId: currentTenant.Id, emergenzaAssistitoId: props.emergenzaAssistitoId }));
      }
      else {
        setFormData({
          assistenza: true
        });
      }

      setLoadPanelVisible(false);
    })();

  }, [props.emergenzaAssistitoId]);

  useImperativeHandle(ref, () => ({
    async save() {
      if (formData) {
        const api = new EmergenzeApi(apiConfiguration);

        setLoadPanelVisible(true);

        try {
          if (props.emergenzaAssistitoId) {
            await api.updateEmergenzaAssistiti({
              tenantId: currentTenant.Id,
              emergenzaAssistitoId: props.emergenzaAssistitoId,
              emergenzaId: String(formData?.emergenzaId),
              emergenzaAssistitoUpdateDTO: formData
            });

            props.onchanged?.();
          }

          return true;
        }
        catch (e) {
          showError(e);
          return false;
        }
        finally {
          setLoadPanelVisible(false);
        }

      }
      else {
        notify("Correggere gli errori di validazione", "error", 2000);
        return false;
      }
    }
  }));

  useEffect(() => {
    console.log('Form data changed:', formData);

  }, [formData]);

  return (
    <React.Fragment>
      <div className="form">
        <div className="dx-fieldset">
          <div className="dx-field">
            <div className="dx-field-label">Tipo di assistenza</div>
            <RadioGroup
              className="dx-field-value"
              items={[{ text: 'Gestito', value: true }, { text: 'Assistito non trovato', value: false }]}
              layout="horizontal"
              value={formData?.assistenza}
              valueExpr="value"
              onValueChanged={(e: any) => {
                setFormData((prev: any) => ({
                  ...prev,
                  assistenza: e.value
                }));
              }} />
          </div>
        </div>

        {formData && formData.assistenza && (
          <React.Fragment>
            <div className="dx-fieldset">
              <div className="dx-field">
                <div className="dx-field-label">Assistito prelevato</div>
                <RadioGroup
                  className="dx-field-value"
                  items={[{ text: 'Si', value: true }, { text: 'No', value: false }]}
                  layout="horizontal"
                  value={formData?.prelevato}
                  valueExpr="value"
                  onValueChanged={(e: any) => {
                    setFormData((prev: any) => ({
                      ...prev,
                      prelevato: e.value
                    }));
                  }} />
              </div>
            </div>

            {formData.prelevato && (
              <div className="dx-fieldset">
                <div className="dx-field">
                  <div className="dx-field-label">Punto di raccolta</div>
                  <Lookup
                    className="dx-field-value"
                    dataSource={puntiDiRaccoltaDataSource}
                    displayExpr='nome'
                    valueExpr='id'
                    value={formData?.puntoDiRaccoltaId}
                    onValueChanged={(e) => {
                      console.log("Punto di raccolta selezionato:", e.value);
                      setFormData((prev: any) => ({
                        ...prev,
                        puntoDiRaccoltaId: e.value
                      }));
                    }}
                  />
                </div>
                <div className="dx-field">
                  <div className="dx-field-label">Altro luogo</div>
                  <TextArea
                    className="dx-field-value"
                    value={formData?.altroLuogo}
                    onValueChanged={(e) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        altroLuogo: e.value
                      }));
                    }}
                  />
                </div>
              </div>
            )}

            {formData.prelevato === false && (
              <div className="dx-fieldset">
                <div className="dx-field">
                  <div className="dx-field-label">Note rifiuto / motivazione</div>
                  <TextArea
                    className="dx-field-value"
                    value={formData?.noteRifiuto}
                    onValueChanged={(e) => {
                      setFormData((prev: any) => ({
                        ...prev,
                        noteRifiuto: e.value
                      }));
                    }}
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaAssistitoCompletaPanel);